import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-counsilling-admisson',
  templateUrl: './counsilling-admisson.component.html',
  styleUrls: ['./counsilling-admisson.component.css']
})
export class CounsillingAdmissonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
